import React from 'react';
import { styled } from '@mui/material/styles';
import { useTranslation } from "react-i18next";

const StatusContainer = styled('div')(({ status, failStatus, theme }) => ({
  backgroundColor: failStatus 
    ? '#F44336' 
    : status === 'finished' 
      ? '#4CAF50' 
      : '#9C27B0',
  color: 'white',
  padding: '4px 12px',
  borderRadius: '12px',
  fontSize: '0.75rem',
  fontWeight: '500',
  display: 'inline-block',
  whiteSpace: 'nowrap',
  textTransform: 'capitalize'
}));

export default function StatusBadge({ status, failStatus = false }) {
  const { t } = useTranslation("global");
  
  const statusText = failStatus ? 'error' : status;
  
  return (
    <StatusContainer status={status} failStatus={failStatus}>
      {t(`caseStatus.${statusText}`)}
    </StatusContainer>
  );
}